import React from 'react'

const Hollow = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="9" cy="9" r="8.25" stroke="black" strokeWidth="1.5" strokeDasharray="3 3"/>
</svg>

  )
}

export default Hollow
